export default __webpack_public_path__ + "static/media/parallax-bg35.1c308686.jpg";